import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ThemeConstellation } from '@zillow/constellation';
import { Form } from '@zillow/constellation-10';

import { DISPLAY_SERVER_ERROR_AT } from '../../../constants/WizardConstants';

import { ModularListingContext } from '../../../containers/CreateListingPage/context';
import { WizardContext } from '../../Wizard/context';

import WizardAlert from '../../WizardAlert';
import WizardTipCardContainer from '../../WizardTipCardContainer';
import PageWizard from '../../Wizard/PageWizard';

import { RECS } from '../../../constants/RecommendationsConstants';

import PetPolicyFormField from './components/PetPolicyFormField';
import WizardTipContent from './components/WizardTipContent';

import { WizardBody, WizardFlexContainer, WizardFormSectionContainer, WizardHeading } from '../../../styles/wizard';

const propTypes = {
  onGoToPrevStep: PropTypes.func.isRequired,
  onGoToNextStep: PropTypes.func.isRequired,
  wizardTitle: PropTypes.node.isRequired,
  progressStepper: PropTypes.node.isRequired,
  totalSteps: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  showDesktopViewBreakpoint: PropTypes.oneOf(Object.keys(ThemeConstellation.ns().breakpoints)).isRequired,
};
const defaultProps = {};

const PetPolicy = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}) => {
  const {
    wizardState: { isFetchingData },
  } = useContext(WizardContext);

  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  const petsRec = RECS.PETS_NOT_ALLOWED;

  const [clickedNext, setClickedNext] = useState(false);
  const [clickedBackNext, setClickedBack] = useState(false);

  useEffect(() => {
    const { fieldName } = serverErrorObj;

    if (!fieldName && !isFetchingData) {
      checkNavToStep();
    }
  }, [isFetchingData]);

  const checkNavToStep = () => {
    if (clickedNext) {
      onNextClick();
    }

    if (clickedBackNext) {
      onBackClick();
    }
  };

  const onNextClick = () => {
    if (isFetchingData) {
      setClickedNext(true);
      return;
    }

    onGoToNextStep();
  };

  const onBackClick = () => {
    if (isFetchingData) {
      setClickedBack(true);
      return;
    }

    onGoToPrevStep();
  };

  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onNextClick}
      onBackClick={onBackClick}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <div className="PetPolicy">
        <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.PAGE} />
        <WizardFlexContainer>
          {/* cast as div to prevent cannot appear as a descendant of form error */}
          <Form asChild={true} onSubmit={(e) => e.preventDefault()}>
            <div>
              <WizardFormSectionContainer>
                <WizardHeading level={1} textStyle="heading-sm">
                  What&#39;s your pet policy?
                </WizardHeading>
                <WizardBody>Let renters know if you allow pets and, if so, what kind.</WizardBody>

                <PetPolicyFormField />
              </WizardFormSectionContainer>
            </div>
          </Form>

          {!!petsRec?.outcomeStats && (
            <WizardTipCardContainer
              header="Consider allowing pets"
              showDesktopViewBreakpoint={showDesktopViewBreakpoint}
            >
              <WizardTipContent outcomeStats={petsRec?.outcomeStats} source={petsRec?.source?.tip} />
            </WizardTipCardContainer>
          )}
        </WizardFlexContainer>
      </div>
    </PageWizard>
  );
};

PetPolicy.propTypes = propTypes;
PetPolicy.defaultProps = defaultProps;

export default PetPolicy;
